import { FC } from 'react';
import { Container } from 'react-bootstrap';
import cn from 'classnames';
import styles from './LandscapeAboutCommittedBuyersAddPartnerTemplate.module.css';
import BaseTemplate from '../BaseTemplate';
import { LandscapeAboutCommittedBuyersPartnerOrganism } from '../../organisms';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Label } from '../../atoms';
import { LandscapeSupportersResponseDto } from '../../../store/tradeAPI/commodity/dto/response/landscape-suporters-response.dto';

interface LandscapeAboutCommittedBuyersAddPartnerTemplateProps {
  callbackFn: (supporter: LandscapeSupportersResponseDto) => void;
  supporter: LandscapeSupportersResponseDto;
  handleOnChange: (supporter: LandscapeSupportersResponseDto) => void;
}

const LandscapeAboutCommittedBuyersAddPartnerTemplate: FC<
  LandscapeAboutCommittedBuyersAddPartnerTemplateProps
> = ({ callbackFn, supporter, handleOnChange }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <>
      <BaseTemplate>
        <Container>
          <div className={cn(styles.heading)}>
            <Label content="Add Partner" size="lg" />
            <Button
              className={styles.buttonLink}
              onClick={() =>
                navigate(`/landscapes/edit/${id}/about/committed-buyers`)
              }
              variant="link"
            >
              Go back to overview
            </Button>
          </div>
          <LandscapeAboutCommittedBuyersPartnerOrganism
            callbackFn={callbackFn}
            supporter={supporter}
            handleOnChange={handleOnChange}
          />
        </Container>
      </BaseTemplate>
    </>
  );
};

export default LandscapeAboutCommittedBuyersAddPartnerTemplate;
